export const includesIgnoreCase = (str?: string, searchStr?: string) =>
    str?.toLowerCase().includes(searchStr?.toLowerCase() || '');

export const cleanStringWithRegex = (
    value: string,
    allowedChars: string[] | undefined = [],
): string => {
    // Базовые символы для удаления
    const defaultUnwantedChars = ['\\n', '\\t', '@', '#', '<', '>', '&', '*', '^', '~'];

    // Создаем паттерн для удаления
    const pattern = defaultUnwantedChars
        .filter((char) => !allowedChars.includes(char)) // исключаем разрешенные символы
        .map((char) => (char.length > 1 ? char : `\\${char}`)) // экранируем специальные символы
        .join('|');

    // Создаем регулярное выражение
    const regex = new RegExp(`[${pattern}]`, 'g');

    return value.replace(regex, '');
};
